import { Check } from "lucide-react"

import { SubstepIndicator } from "@/components/flow-progress-bar/SubstepIndicator"
import { cn } from "@/lib/utils"

function StepIcon({
  status,
}: {
  status: "active" | "completed" | "incomplete"
}) {
  return (
    <div
      className={cn(
        "flex size-9 items-center justify-center",
        "rounded-full border-2 transition-colors",
        status === "incomplete" && "border-muted/40",
        status === "active" && "border-primary",
        status === "completed" && "border-primary",
      )}
    >
      <div
        className={cn(
          "rounded-full transition-all",
          "flex items-center justify-center",
          status === "incomplete" && "bg-muted/40 size-3",
          status === "active" && "bg-primary size-4",
          status === "completed" && "bg-primary size-9",
        )}
      >
        {status === "completed" && (
          <Check className="size-6 text-white" strokeWidth={2} />
        )}
      </div>
    </div>
  )
}

interface StepIndicatorProps {
  step: string
  status: "active" | "completed" | "incomplete"
  substep?: number
  totalSubsteps: number
}

export function StepIndicator({
  step,
  status,
  substep,
  totalSubsteps,
}: StepIndicatorProps) {
  return (
    <div className="flex shrink-0 items-center gap-2">
      <StepIcon status={status} />
      <div className="flex h-full flex-col gap-1">
        <span className="text-sm leading-tight sm:text-base">{step}</span>
        {status === "active" && totalSubsteps > 1 && (
          <SubstepIndicator
            currentSubstep={substep || 1}
            totalSubsteps={totalSubsteps}
          />
        )}
      </div>
    </div>
  )
}
